export default () => {
  return document.cookie.replace(/(?:(?:^|.*;\s*)XSRF-TOKEN\s*\\=\s*([^;]*).*$)|^.*$/, '$1')
}



// WEBPACK FOOTER //
// ./src/config/fetch/cookieExpression.js